<template>
  <div class="noPreview">
    <heading type="h1">AWAITING RENDER</heading>
  </div>
</template>

<script>
import Heading from '@/components/Heading/heading'

export default {
  name: 'noPreview',
  components: {
    Heading
  }
}
</script>

<style lang="scss">
    .noPreview {
        padding-top: 40px;
        text-align: center;
        width:100%;
        height:100%;
        background-color: black;
        color: white;
        position: absolute;
        top:0;
        left:0;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dev/no-preview.vue